module.exports = __webpack_public_path__ + "static/img/28.5145659.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/28.png
// module id = xcm/
// module chunks = 1